// @flow
import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';

import Scrollable from '../shared/Scrollable';
import StyledForm from '../shared/StyledForm';
import Button from '../shared/Button';
import DatePicker from '../shared/forms/DatePicker';
import DropdownList from '../shared/forms/DropdownList';

import { getContacts } from '../../selectors/shared';

import { loadContacts } from '../../redux/reducers/contacts';

const validate = values => {
    const errors = {};

    if (!values.fromContactId) {
        errors.fromContactId = 'From contact is required';
    }

    if (!values.toContactId) {
        errors.toContactId = 'To contact is required';
    }

    if (!values.startAt) {
        errors.startAt = 'A start date is required';
    }

    if (!values.rollBackAt) {
        errors.rollBackAt = 'A roll back date is required';
    }

    if (
        values.startAt &&
        values.rollBackAt &&
        values.rollBackAt < values.startAt
    ) {
        errors.rollBackAt = 'Roll back date cannot be before start date';
    }

    return errors;
};

class ContactReassignsAddForm extends Component {
    componentDidMount() {
        this.props.dispatch(loadContacts(1, 9999));
    }

    render() {
        const { handleSubmit, submitting, dirty, error, contacts } = this.props;

        const data = Array.isArray(contacts)
            ? contacts.map(contact => {
                  return {
                      id: contact.contactId,
                      label: `${contact.contactForenames} ${contact.contactSurname}`,
                  };
              })
            : [];

        return (
            <StyledForm onSubmit={handleSubmit}>
                <Prompt
                    when={dirty}
                    message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
                />

                <Scrollable additionalClassName="scroll-area">
                    <div className="flex">
                        <div className="col">
                            <Field
                                name="fromContactId"
                                label="From Contact"
                                component={DropdownList}
                                data={data}
                                error={error}
                            />
                            <Field
                                name="toContactId"
                                label="To Contact"
                                component={DropdownList}
                                data={data}
                                error={error}
                            />
                        </div>
                        <div className="col">
                            <Field
                                name="startAt"
                                label="Starting at"
                                component={DatePicker}
                                error={error}
                            />
                            <Field
                                name="rollBackAt"
                                label="Roll back at"
                                component={DatePicker}
                                error={error}
                            />
                        </div>
                    </div>
                </Scrollable>
                <div className="sticky-footer">
                    <Button type="submit" disabled={submitting}>
                        Save & Continue
                    </Button>
                </div>
            </StyledForm>
        );
    }
}

const mapStateToProps = state => {
    const add = state.contactreassigns.add;

    return {
        contactReassigns: add.contactreassigns,
        contacts: getContacts(state),
    };
};

export default reduxForm({
    form: 'contactReassignsAddForm',
    validate,
})(connect(mapStateToProps)(ContactReassignsAddForm));



// WEBPACK FOOTER //
// ./src/components/ContactReassigns/Add.js